import { z } from "zod";

export const ChannexValidationError = z.object({
    warning: z.record(z.array(z.string())), // bagian dinamis di sini
    date_from: z.string(),
    date_to: z.string(),
    property_id: z.string(),
    rate_plan_id: z.string(),
    rate: z.string(),
});

export const ChannexValidationErrorResponse = z.object({
    code: z.number(),
    success: z.boolean(),
    message: z.string(),
    errors: z.array(ChannexValidationError),
});

export type ChannexValidationErrorResponseData = z.infer<typeof ChannexValidationErrorResponse>;
